import { render, staticRenderFns } from "./CompBottleSplash.vue?vue&type=template&id=459c4dad&scoped=true"
import script from "./CompBottleSplash.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompBottleSplash.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompBottleSplash.vue?vue&type=style&index=0&id=459c4dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c4dad",
  null
  
)

export default component.exports